export default "__VITE_ASSET__826ca45d__"